


import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import validator from '../../api/validator';
import lrz from 'lrz';
import api from '../../api';
import UpLoad from '../../components/LoansUpload';

export default {

beforeRouteEnter: (to, from, next) => {
next((vm) => {
});
},
components: {
CheckIcon,
Group,
XInput,
XButton,
UpLoad,
},
mounted() {
const query = this.$route.query;
if (query.status !== undefined) {
this.isEdit = true;
if (query.status) {
query.status = true;
} else {
query.status = false;
}
this.formData = query;
}
},
activated() {
},
data() {
return {
isEdit: false,
formData: {
name: '',
mobile: '',
tel: '',
mail: '',
position: '',
status: false,
},
rule: {
isMobile(val) {
return {
valid: validator.isMobile(val),
msg: '请输入正确的手机号码',
};
},
isTel(val) {
return {
valid: validator.isTel(val),
msg: '请输入正确的座机号码',
};
},
isMail(val) {
return {
valid: validator.isMail(val),
msg: '请输入正确的邮箱',
};
},
},
};
},
computed: {
},
methods: {
save(delet) {
const { name, mobile, status, tel, mail, position, id } = this.formData;
let _status;
let param;
if (status) {
_status = 1;
} else {
_status = 0;
}
if (this.isEdit) {
param = {
name,
mobile,
status: _status,
tel,
mail,
position,
id,
};
} else {
param = {
name,
mobile,
status: _status,
tel,
mail,
position,
};
}
if (delet) {
param.deleted = 1;
}

if (!this.rule.isMobile(mobile).valid || !this.rule.isTel(tel).valid ||!this.rule.isMail(mail).valid) {
this.$vux.toast.text('请填写正确的信息');
} else {
api.vega.contact.updateContact(param).then((res) => {
const code = res.data;
if (code.code === 0 && code.sub_code === 0 ) {
if (!delet) {
this.$vux.toast.text('保存成功');
} else {
this.$vux.toast.text('删除成功');
}
this.$router.go(-1);
}
});
}
},
deleLink() {

},
},
};
